var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOlympicFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25C9.5 4.25 10.5 5.875 12 7.125C13.5 8.375 14.25 9.75 14.25 11.25C14.25 12.6424 13.6969 13.9777 12.7123 14.9623C11.7277 15.9469 10.3924 16.5 9 16.5C7.60761 16.5 6.27226 15.9469 5.28769 14.9623C4.30312 13.9777 3.75 12.6424 3.75 11.25C3.75 10.4386 4.01317 9.64911 4.5 9C4.5 9.49728 4.69754 9.97419 5.04917 10.3258C5.40081 10.6775 5.87772 10.875 6.375 10.875C6.87228 10.875 7.34919 10.6775 7.70083 10.3258C8.05246 9.97419 8.25 9.49728 8.25 9C8.25 7.5 7.125 6.75 7.125 5.25C7.125 4.25 7.75 3.25 9 2.25Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlympicFlame);
export default __webpack_public_path__ + "static/media/olympic-flame.6a14adf4961c27b922aafa66b0663c74.svg";
export { ForwardRef as ReactComponent };